import React from "react";
import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { Text, TextBold, TextLarge } from "./StudyManagerShared.styles";
import { HXSectionCard } from "./HXDesktopPage.styles";
import { HXAutocomplete } from "./HXAutocomplete";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { BaseTextButton } from "./base.styles";
import { ChartJSBarChart, ChartJSPieChart } from "./ChartJSCharts";
export const TitleAndFilterContainer = styled.div `
    display: flex;
    padding: 0px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;
export const FilterAutocomplete = styled(HXAutocomplete) `
    display: flex;
    align-items: flex-start;
    background: ${colors.white_main};
    width: 350px;
`;
export const EnrollmentSection = styled(HXSectionCard) `
    padding: 40px;
    gap: 40px;
`;
export const ProgressBarContainer = styled(FlexColumnDiv) `
    align-items: flex-start;
    align-self: stretch;
    gap: 8px;
`;
export const ProgressBarOuter = styled.div `
    position: relative;
    align-self: stretch;
    height: 24px;
    border-radius: 100px;
    background: ${colors.black_12};
`;
const BaseProgressBarInner = styled.div `
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${(props) => `${props.width}%`};
    border-radius: 100px;
    background: linear-gradient(135deg, ${colors.accents_gradient_start} 0%, ${colors.accents_sunset} 100%);
`;
export const ProgressBarInnerTotal = styled(BaseProgressBarInner) ``;
export const ProgressBarDataContainer = styled(FlexRowDiv) `
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;
export const ProgressBarStartDataPointContainer = styled(FlexColumnDiv) `
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
`;
export const ProgressBarEndDataPointContainer = styled(ProgressBarStartDataPointContainer) `
    align-items: flex-end;
`;
export const ProgressBarDataPointTitleLabel = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_main};
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const ProgressBarDataPointValueLabel = styled(ProgressBarDataPointTitleLabel) `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_light};
    letter-spacing: 0.17px;
`;
export const ConsentSection = styled(HXSectionCard) `
    flex-direction: row;
    padding: 24px;
    justify-content: space-evenly;
`;
export const ConsentInfoContainer = styled(FlexColumnDiv) `
    gap: 8px;
    align-items: center;
    flex-shrink: 0;
    align-self: stretch;
`;
export const ConsentInfoTextBold = styled(TextBold) `
    text-align: center;
    align-self: stretch;
`;
export const ConsentInfoTextLarge = styled(TextLarge) `
    text-align: center;
    align-self: stretch;
`;
export const ConsentInfoText = styled(Text) `
    text-align: center;
    align-self: stretch;
`;
export const RecruitmentSection = styled(HXSectionCard) `
    padding: 40px;
    gap: 40px;
    align-items: center;
`;
export const RecruitmentBreakdownContainer = styled(FlexRowDiv) `
    padding: 0;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
    justify-content: center;
    flex-wrap: wrap;
`;
export const RecruitmentBreakdownPointContainer = styled(FlexColumnDiv) `
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    gap: 8px;
    padding: 0;
    flex: 1 0 0;
`;
export const RecruitmentBreakdownPointTitle = styled(TextBold) `
    height: 38px;
`;
export const ColumnChartWrapper = styled.div `
    width: 100%;
`;
export const ColumnChart = styled(ChartJSBarChart) `
    /* Need to artifically increase width to account for the fact that the RecruitmentBreakdownContainer has a gap configured
    and that increases the width only n - 1 times, not n times, given the way gap works. 49 = 24 + 1 + 24 to account for the 
    gaps and the horizontal dividers between elements. This results in bars aligned exactly with the above breakdown labels. */
    width: calc(100% + 49px);
    height: 300px;
    /* Translate left by percentage equal to half of one bar to move from center to left aligned */
    /* Then counter-correct by half of the actual bar itself (80px bars => 40px) */
    transform: translateX(-${(props) => (100 / Object.keys(props.chartData).length) * 0.5}%) translateX(40px);
`;
export const WhatsNewSection = styled(HXSectionCard) ``;
export const WhatsNewContainer = styled(FlexRowDiv) `
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-bottom: 1px solid ${colors.black_12};
`;
export const WhatsNewText = styled(Text) `
    color: ${colors.black_main};
`;
export const SeeDetailsButton = styled(BaseTextButton).attrs({ variant: "text", endIcon: React.createElement(ChevronRight) }) `
    padding: 0 8px;
`;
export const SectionRow = styled(FlexRowDiv) `
    width: 100%;
    justify-content: space-between;
    gap: 24px;

    & > * {
        flex-grow: 1;
    }
`;
export const PieChartSection = styled(HXSectionCard) `
    padding: 24px;
    gap: 8px;
    align-items: center;
`;
export const SmallerSectionTitle = styled.div `
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const PieChart = styled(ChartJSPieChart) `
    width: 500px;
    height: 350px;
`;
